import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card'
import { AuthLayout } from '@/components/layout/AuthLayout'
import { ROUTES } from '@/config/routes'

export const ResetPasswordInvalidPage = () => {
  return (
    <AuthLayout>
      <Card>
        <CardHeader>
          <CardTitle>Invalid Reset Link</CardTitle>
          <CardDescription>This password reset link is invalid or has expired</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="rounded-md bg-destructive/10 p-4 text-sm text-destructive">
            The password reset link you followed is either invalid or has expired.
            Password reset links are only valid for 24 hours.
          </div>
        </CardContent>
        <CardFooter className="flex flex-col space-y-2">
          <Button asChild className="w-full">
            <Link to={ROUTES.FORGOT_PASSWORD}>
              Request New Reset Link
            </Link>
          </Button>
          <Button asChild variant="outline" className="w-full">
            <Link to={ROUTES.LOGIN}>
              Back to Login
            </Link>
          </Button>
        </CardFooter>
      </Card>
    </AuthLayout>
  )
}
